import { replace } from 'ramda';

export default value => replace(/[^\d]+/g, '', value);
